export default __webpack_public_path__ + "static/media/cross_black.9b2e17d8.svg";